import { render } from "./MsPopoverGlobal.vue?vue&type=template&id=794abf8e&scoped=true"
import script from "./MsPopoverGlobal.vue?vue&type=script&lang=js"
export * from "./MsPopoverGlobal.vue?vue&type=script&lang=js"

import "./MsPopoverGlobal.vue?vue&type=style&index=0&id=794abf8e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794abf8e"]])

export default __exports__